<template>
  <div>
    <v-card class="ma-2">
      <v-card-title class="primary--text">
        <v-layout align-center justify-space-between>
          <h3 class="ma-3">{{ $route.params.id }}</h3>
          <v-btn v-if="getCurrentDevicePir" @click="togglePir" class="ma-3" color="warning">
            <v-icon left>mdi-motion-sensor</v-icon>
            {{ $t('sensor.disablepir') }}
          </v-btn>
          <v-btn v-else class="ma-3" @click="togglePir" color="primary">
            <v-icon left>mdi-motion-sensor</v-icon>
            {{ $t('sensor.enablepir') }}
          </v-btn>
        </v-layout>
      </v-card-title>
      <v-container fluid grid-list-xl class="mt-0 pt-0">
        <v-row wrap class="ma-2">
          <v-col>
            <v-layout row class="pl-4">
              <b>{{ $t('device.detail.ambient') }}</b>
            </v-layout>
            <v-layout row class="mt-1">
              <v-flex v-for="item in sensorItems" :key="item.key" sm6 md3 lg2 class="pt-0 pb-0">
                <value-editor
                  :detail="item.value"
                  readonly="RO"
                  :fieldlabel="item.label"
                  :suffix="item.uom"
                  type="STRING"
                ></value-editor>
              </v-flex>
            </v-layout>

            <v-layout row class="pt-4 pl-4 mt-3">
              <b>{{ $t('device.detail.gps') }}</b>
            </v-layout>
            <v-layout row class="mt-1">
              <v-flex v-for="item in gpsItems" :key="item.key" sm6 md3 lg2 class="pt-0 pb-0">
                <value-editor
                  :detail="item.value"
                  readonly="RO"
                  :fieldlabel="item.label"
                  :suffix="item.uom"
                  type="STRING"
                ></value-editor>
              </v-flex>
            </v-layout>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card class="ma-2" v-if="debug">
      <v-card-title class="primary--text">
        <h3>{{ $t('device.detail.saedata') }}</h3>
      </v-card-title>
      <v-container fluid grid-list-xl class="mt-0 pt-0">

        <v-row wrap class="ma-2">
          <v-flex v-for="item in saeStatusItems" :key="item.key" :class="item.class">
            <value-editor
              :detail="item.value"
              readonly="RO"
              :choices="item.items"
              :label="item.label"
              :suffix="item.uom"
              type="SELECT"
            ></value-editor>
          </v-flex>
        </v-row>
        <v-row wrap class="ma-2">
          <v-flex v-for="item in saeItems" :key="item.key" :class="item.class">
            <value-editor
              :detail="item.value"
              readonly="RO"
              :fieldlabel="item.label"
              suffix=""
              type="INTEGER"
            ></value-editor>
          </v-flex>
        </v-row>
      </v-container>
    </v-card>

    <v-card class="ma-2" v-if="false">
      <v-card-title class="primary--text">
        <h3>{{ $t('device.detail.saeconfiguration') }}</h3>
      </v-card-title>
      <v-container fluid grid-list-xl class="mt-3 pt-0">
        <v-layout class="ma-2">
          <v-flex sm6 md4 lg2 class="pt-0 pb-0">
            <value-editor
              :detail="wrrequest.cmd1"
              :choices="comandi1"
              :label="$t('common.command1.name')"
              @change="change('cmd1', arguments[0])"
              :readonly="readonly"
              type="SELECT"
            ></value-editor>
          </v-flex>
          <v-flex sm6 md4 lg3 class="pt-0 pb-0" v-if="wrrequest.cmd1 == 49">
            <value-editor
              :detail="wrrequest.cmd2"
              :choices="comandi2"
              :label="$t('common.command2.name')"
              @change="change('cmd2', arguments[0])"
              :readonly="readonly"
              type="SELECT"
            ></value-editor>
          </v-flex>
          <v-flex sm6 md4 lg3 class="pt-0 pb-0" v-if="wrrequest.cmd1 == 49">
            <value-editor
              :detail="wrrequest.cmd3"
              :choices="comandi3"
              :label="$t('common.command3.name')"
              @change="change('cmd3', arguments[0])"
              :readonly="readonly"
              type="SELECT"
            ></value-editor>
          </v-flex>
          <v-flex sm6 md4 lg2 class="pt-0 pb-0" v-if="wrrequest.cmd1 == 49">
            <value-editor
              :detail="wrrequest.cmd4"
              :choices="comandi4"
              :label="$t('common.command4.name')"
              @change="change('cmd4', arguments[0])"
              :readonly="readonly"
              type="SELECT"
            ></value-editor>
          </v-flex>
          <v-flex sm6 md4 lg1 class="pt-0 pb-0" v-if="wrrequest.cmd1 == 49 && wrrequest.cmd3 == 48">
            <value-editor
              :detail="wrrequest.i"
              :fieldlabel="$t('common.unit.i')"
              @change="change('i', arguments[0])"
              :readonly="readonly"
              type="INTEGER"
            ></value-editor>
          </v-flex>
          <v-flex sm6 md4 lg1 class="pt-0 pb-0" v-if="wrrequest.cmd1 == 49 && wrrequest.cmd3 == 49">
            <value-editor
              :detail="wrrequest.v"
              :fieldlabel="$t('common.unit.v')"
              @change="change('v', arguments[0])"
              :readonly="readonly"
              type="INTEGER"
            ></value-editor>
          </v-flex>
          <v-flex sm6 md4 lg1 class="pt-0 pb-0" v-if="wrrequest.cmd1 == 49">
            <value-editor
              :detail="wrrequest.hz"
              :fieldlabel="$t('common.unit.hz')"
              @change="change('hz', arguments[0])"
              :readonly="readonly"
              type="INTEGER"
            ></value-editor>
          </v-flex>
          <v-flex sm12 md1 class="pt-0">
            <v-btn color="primary" :disabled="disableButton" @click="dialog = true">
              {{ $t('common.set') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex"

export default {
  data() {
    return {
      comandi1: [
        { id: 48, value: this.$i18n.t('common.command1.48') },
        { id: 49, value: this.$i18n.t('common.command1.49') },
        { id: 50, value: this.$i18n.t('common.command1.50') },
      ],
      comandi2: [
        { id: 48, value: this.$i18n.t('common.command2.48') },
        { id: 49, value: this.$i18n.t('common.command2.49') },
        { id: 50, value: this.$i18n.t('common.command2.50') },
        { id: 51, value: this.$i18n.t('common.command2.51') },
      ],
      comandi3: [
        { id: 48, value: this.$i18n.t('common.command3.48') },
        { id: 49, value: this.$i18n.t('common.command3.49') },
      ],
      comandi4: [
        { id: 49, value: this.$i18n.t('common.command4.49') },
        { id: 50, value: this.$i18n.t('common.command4.50') },
        { id: 51, value: this.$i18n.t('common.command4.51') },
      ],
      stato1: [
        { id: 48, value: this.$i18n.t('common.status1.48') },
        { id: 49, value: this.$i18n.t('common.status1.49') },
        { id: 50, value: this.$i18n.t('common.status1.50') },
        { id: 51, value: this.$i18n.t('common.status1.51') },
      ],
      stato2: [
        { id: 48, value: this.$i18n.t('common.status2.48') },
        { id: 49, value: this.$i18n.t('common.status2.49') },
      ],
      stato3: [
        { id: 48, value: this.$i18n.t('common.status3.48') },
        { id: 49, value: this.$i18n.t('common.status3.49') },
      ],
      stato4: [
        { id: 48, value: this.$i18n.t('common.status4.48') },
        { id: 49, value: this.$i18n.t('common.status4.49') },
      ],
      stato5: [
        { id: 49, value: this.$i18n.t('common.status5.49') },
        { id: 50, value: this.$i18n.t('common.status5.50') },
        { id: 51, value: this.$i18n.t('common.status5.51') },
      ],
      wrrequest: {
        cmd1: null,
        cmd2: null,
        cmd3: null,
        cmd4: null,
        i: null,
        v: null,
        hz: null
      },
      updating: false,
    }
  },
  mounted() {
    if (this.getCurrentDevice) {
      this.wrrequest.cmd1 = this.getCurrentDevice.sae.s1 == 48 ? 48 : 49
      this.wrrequest.cmd2 = this.getCurrentDevice.sae.s2
      this.wrrequest.cmd3 = this.getCurrentDevice.sae.s4
      this.wrrequest.cmd4 = this.getCurrentDevice.sae.s5
      this.wrrequest.i = this.getCurrentDevice.sae.impiout
      this.wrrequest.v = this.getCurrentDevice.sae.impvout
      this.wrrequest.hz = this.getCurrentDevice.sae.imphzout
    }
  },
  watch: {
    getCurrentDevice(newvalue) {
      if (newvalue != undefined) {
        this.wrrequest.cmd1 = this.getCurrentDevice.sae.s1 == 48 ? 48 : 49
        this.wrrequest.cmd2 = this.getCurrentDevice.sae.s2
        this.wrrequest.cmd3 = this.getCurrentDevice.sae.s4
        this.wrrequest.cmd4 = this.getCurrentDevice.sae.s5
        this.wrrequest.i = newvalue.sae.impiout
        this.wrrequest.v = newvalue.sae.impvout
        this.wrrequest.hz = newvalue.sae.imphzout
      }
    }
  },
  computed: {
    ...mapGetters([
      "getCurrentDevice",
      "getCurrentDevicePir",
    ]),
    sensorItems() {
      return [
        { value: this.getCurrentDevice.sensors.ambient.pre, label: this.$i18n.t('sensors.ambient.eco2') },
        { value: this.getCurrentDevice.sensors.ambient.aq, label: this.$i18n.t('sensors.ambient.etvoc') },
        { value: this.getCurrentDevice.sensors.ambient.hum, label: this.$i18n.t('sensors.ambient.hum'), uom: this.$i18n.t('common.unit.hum') },
        { value: this.getCurrentDevice.sensors.ambient.temp, label: this.$i18n.t('sensors.ambient.temp'), uom: this.$i18n.t('common.unit.temp') }
      ]
    },
    gpsItems() {
      return [
        { value: this.getCurrentDevice.sensors.gps?.lat, label: this.$i18n.t('sensors.gps.lat') },
        { value: this.getCurrentDevice.sensors.gps?.lon, label: this.$i18n.t('sensors.gps.lon') }
      ]
    },
    saeStatusItems() {
      if (this.getCurrentDevice.sae)
        return [
          { value: this.getCurrentDevice.sae.s1, items: this.stato1, label: this.$i18n.t('common.status1.name'), class:"pt-0 pb-0 col-sm-6 col-md-4 col-lg-2" },
          { value: this.getCurrentDevice.sae.s2, items: this.stato2, label: this.$i18n.t('common.status2.name'), class:"pt-0 pb-0 col-sm-6 col-md-4 col-lg-2" },
          { value: this.getCurrentDevice.sae.s3, items: this.stato3, label: this.$i18n.t('common.status3.name'), class:"pt-0 pb-0 col-sm-6 col-md-4 col-lg-2" },
          { value: this.getCurrentDevice.sae.s4, items: this.stato4, label: this.$i18n.t('common.status4.name'), class:"pt-0 pb-0 col-sm-6 col-md-4 col-lg-3" },
          { value: this.getCurrentDevice.sae.s5, items: this.stato5, label: this.$i18n.t('common.status5.name'), class:"pt-0 pb-0 col-sm-6 col-md-4 col-lg-2" }
        ]
      return []
    },
    saeItems() {
      if (this.getCurrentDevice.sae)
        return [
          { value: this.getCurrentDevice.sae.iout, label: this.$i18n.t('common.unit.i'), uom: this.$i18n.t('common.unit.i'), class:"pt-0 pb-0 col-sm-6 col-md-4 col-lg-1" },
          { value: this.getCurrentDevice.sae.vout, label: this.$i18n.t('common.unit.v'), uom: this.$i18n.t('common.unit.v'), class:"pt-0 pb-0 col-sm-6 col-md-4 col-lg-1" },
          { value: this.getCurrentDevice.sae.hzout, label: this.$i18n.t('common.unit.hz'), uom: this.$i18n.t('common.unit.hz'), class:"pt-0 pb-0 col-sm-6 col-md-4 col-lg-1" },
        ]
      return []
    },
    readonly() {
      return this.updating ? "UP" : "WR"
    },
    disableButton() {
      if (this.wrrequest.cmd1 == 49) {
        if (!this.wrrequest.cmd2 || !this.wrrequest.cmd3)
          return true
        if (this.wrrequest.cmd3 == 48 && this.wrrequest.cmd4 && this.wrrequest.i && this.wrrequest.hz)
          return false
        if (this.wrrequest.cmd3 == 49 && this.wrrequest.cmd4 && this.wrrequest.v && this.wrrequest.hz)
          return false
        return true
      }
      return false
    },
    debug() {
      // return this.$TARGET == 'development'
      return true
    }
  },
  methods: {
    ...mapActions(["doSetSAE", "doSetAlarmsState"]),
    ...mapMutations(["mShowLongLoader", "mHideLongLoader"]),
    change(prop,value) {
      this.wrrequest[prop] = value
      if (prop == "cmd1" && (value == 48 || value == 50)) {
        this.wrrequest.cmd2 = 48
        this.wrrequest.cmd3 = 48
        this.wrrequest.cmd4 = 48
      }
    },
    async setDevice() {
      this.dialog = false;
      let payload = {
        id: this.$route.params.id,
        data: this.wrrequest
      }
      this.mShowLongLoader(this.$i18n.t("common.pleasewait"))
      await this.doSetSAE(payload)
      this.mHideLongLoader()
    },
    async togglePir() {
      let payload = {
        dvralarms: !this.getCurrentDevicePir
      }
      this.mShowLongLoader(this.$i18n.t("common.pleasewait"))
      await this.doSetAlarmsState({
        device: this.$route.params.id, 
        data: payload
      })
      this.mHideLongLoader()
    }
  }
}
</script>

<style>

</style>